module.exports = __webpack_public_path__ + "static/media/VIP_4.3b3d9fef.jpg";